import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styles from "./Register.module.scss";
import { useTranslation } from "../i18n";
import { LogoIcon } from "../components/Icons/Logo";
import { LanguageSwitcher } from "../components/LanguageSwitcher/LanguageSwitcher";
import { Button } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
import classNames from "classnames";
import { PolygonIcon } from "../components/Icons/Polygon";
import { OnboardingVolunteer } from "../components/OnboardingVolunteer/OnboardingVolunteer";
import { OnboardingOrganisation } from "../components/OnboardingOrganisation/OnboardingOrganisation";

export type AccountType = "volunteer" | "organisation" | "";

export const Register = () => {
  const { t } = useTranslation();
  const { key } = useParams<{ key?: string }>();
  const navigate = useNavigate();
  const [accountType, setAccountType] = useState<AccountType>("");

  const handleClick = (key: AccountType) => {
    setAccountType(key);
    navigate(`/register/${key}`);
  };

  return (
    <div className={styles.register}>
      <div className={styles.logo}>
        <LogoIcon />
        <LanguageSwitcher />
      </div>
      <section className={styles.content}>
        {key === "volunteer" ? (
          // @ts-ignore - JS component
          <OnboardingVolunteer />
        ) : key === "organisation" ? (
          // @ts-ignore - JS component
          <OnboardingOrganisation />
        ) : (
          <>
            <h2>{t("register.accountType")}</h2>
            <p>{t("register.pickProfile")}</p>
            <form className={styles.form}>
              <Button
                variant="outlined"
                size="large"
                endIcon={<NavigateNextIcon />}
                onClick={() => handleClick("volunteer")}
                className={classNames({
                  [styles.active]: accountType === "volunteer",
                })}
              >
                <span className={styles.pentagon}>
                  {/* @ts-ignore - JS component */}
                  <PolygonIcon active={accountType === "volunteer"} />
                  <PersonOutlineOutlinedIcon color="inherit" />
                </span>
                {t("register.volunteer")}
              </Button>
              <Button
                variant="outlined"
                size="large"
                endIcon={<NavigateNextIcon />}
                onClick={() => handleClick("organisation")}
                className={classNames({
                  [styles.active]: accountType === "organisation",
                })}
              >
                <span className={styles.pentagon}>
                  {/* @ts-ignore - JS component */}
                  <PolygonIcon active={accountType === "organisation"} />
                  <BusinessCenterOutlinedIcon color="inherit" />
                </span>
                {t("register.organisation")}
              </Button>
            </form>
          </>
        )}
      </section>
    </div>
  );
};
